import GenericIndex from 'client/js/resellercp/generic_resource/index';
import { Dropdown } from 'client/js/usercp/table_utils';
import ConfirmedDelete from 'client/js/util/confirmed_delete';
import { FaIcon } from 'client/js/util/layout_utils';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'client/js/util/rest_utils';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';

const Header = () => {
  return (
    <tr>
      <th>Benutzername</th>
      <th>Webspace-Verzeichnis</th>
      <th>Optionen</th>
    </tr>
  )
}

const TableRow = ({item: account, refreshCb}) => {
  return (
    <tr>
      <td>
        <Link to={`/ftp_accounts/${account.id}`}>{account.username}</Link>
        {account.comment && account.comment != "" && (<>
            <br />
            <small className="text-muted">{account.comment}</small>
          </>
        )}
        </td>
      <td>{account.directory ? account.directory : '/'}</td>
      <td>
        <Dropdown>
          <Link to={`/ftp_accounts/${account.id}/edit`} className="dropdown-item"><FaIcon name="pencil" /> Verzeichnis bearbeiten</Link>
          <Link to={`/ftp_accounts/${account.id}/password`} className="dropdown-item"><FaIcon name="key" /> Passwort ändern</Link>
          <Link to={`/ftp_accounts/${account.id}/comment`} className="dropdown-item"><FaIcon name="comment" /> Kommentar bearbeiten</Link>

          {account.deleteable && (
            <ConfirmedDelete
              namespace="usercp"
              onSuccess={refreshCb}
              redirect_back={false}
              resource="ftp_accounts"
              id={account.id}
              button_text={<><FaIcon name="trash" /> löschen</>}
              button_class="dropdown-item text-danger"
              text="Dies wird den FTP-Zugang sofort löschen, der Zugriff ist nicht mehr möglich."
            />
          )}
        </Dropdown>
        </td>
    </tr>
  );
}

const DisabledCreateButton = ({ limit }) => {
  const [tooltipId] = useState(`tooltip${Math.floor(Math.random() * 1000000000)}`);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <button id={tooltipId} className="btn btn-light" disabled>
        <FaIcon name="plus" /> FTP-Account erstellen
      </button>

      <Tooltip
        isOpen={tooltipOpen}
        target={tooltipId}
        toggle={toggle}
      >
        Du hast das Maximum von {limit.max_accounts} FTP-Accounts erreicht.
      </Tooltip>
    </>
  );
};

const Index = () => {
  const { data } = useQuery(
    ['data', 'usercp', 'ftp_accounts', 1],
    () => fetchData('usercp', 'ftp_accounts', {page: 1}),
    {
      keepPreviousData: true,
    }
  );

  const limit = data?.ftp_account_limit;
  
  const customButtons = () => {
    if (!limit) return [];
    
    if (limit.can_create_more) {
      return [
        <Link key="create" to="/ftp_accounts/new" className="btn btn-light">
          <FaIcon name="plus" /> FTP-Account erstellen
        </Link>
      ];
    } else {
      return [
        <DisabledCreateButton key="disabled" limit={limit} />
      ];
    }
  };

  return (
    <GenericIndex 
      namespace="usercp" 
      resource_name="ftp_accounts" 
      row={TableRow} 
      table_header={Header}
      no_create={true}
      buttons={customButtons()}
    />
  );
};

export default Index;
